import { render, staticRenderFns } from "./DialogEditTag.vue?vue&type=template&id=38d0f97a&scoped=true"
import script from "./DialogEditTag.vue?vue&type=script&lang=js"
export * from "./DialogEditTag.vue?vue&type=script&lang=js"
import style0 from "./DialogEditTag.vue?vue&type=style&index=0&id=38d0f97a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d0f97a",
  null
  
)

export default component.exports